import { Box, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import classNames from "classnames";
import _ from "lodash";
import { useRef, useState } from "react";
import { ChangeEvent, memo } from "react";

import { Toast } from "../../../Errors/Toast";
import { CommonFormElProps } from "../../../types";
import { withImageUploader } from "../../HOC";
import styles from "../../ImageUploader.module.scss";
import { SetFileAction, SelectFileAction } from "../../types";

import multiImageUploaderStyles from "./MultiImageUploader.module.scss";

export type MultiImageProps = {
  readonly allowedExtensions: string;
  readonly currentImageNumber: number;
  readonly maxImageNumber: number;
  readonly onImageQuotaExceeded: () => void;
  readonly onSelectFile: SelectFileAction;
  readonly setFiles: SetFileAction;
} & Pick<CommonFormElProps, "id" | "isComplex" | "label">;

const MultiImage = memo<MultiImageProps>(
  ({
    allowedExtensions,
    currentImageNumber,
    setFiles,
    maxImageNumber,
    onImageQuotaExceeded,
    onSelectFile,
  }) => {
    const [errorMessage, setErrorMessage] = useState("");
    const inputEl = useRef<HTMLInputElement>(null);
    const availableImageNumber = maxImageNumber - currentImageNumber;
    const isImageQuotaExceeded = (uploadingImageNumber: number) =>
      currentImageNumber + uploadingImageNumber > maxImageNumber;

    const getIllegalSigns = (name: string) => {
      const illegalSignsList = /[&<>/;*"'\\]/g;
      return [...new Set(name.match(illegalSignsList))];
    };
    const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
      const maxPdfSize = 5 * 1024 * 1024;
      const convertedFiles = onSelectFile(e.target.files);

      if (
        convertedFiles[0].type === "application/pdf" &&
        !_.isEmpty(getIllegalSigns(convertedFiles[0].name))
      ) {
        setErrorMessage("Nazwa załączonego pliku zawiera niedozwolone znaki");
      } else if (
        convertedFiles[0].type === "application/pdf" &&
        convertedFiles[0].size > maxPdfSize
      ) {
        setErrorMessage(
          "Załączono za duży plik, limit wielkości plików PDF wynosi 5MB"
        );
      } else {
        isImageQuotaExceeded(convertedFiles.length) && convertedFiles
          ? onImageQuotaExceeded()
          : setFiles(convertedFiles);

        if (inputEl?.current?.value) {
          inputEl.current.value = "";
        }
      }
    };

    if (!availableImageNumber) {
      return null;
    }

    const handleToastClose = () => {
      setErrorMessage("");
    };

    return (
      <>
        <Toast
          isVisible={!_.isEmpty(errorMessage)}
          handleClose={handleToastClose}
          message={errorMessage}
        />
        <Box className={classNames(styles.selectImage, styles.wrapper)}>
          <Box className={multiImageUploaderStyles.wrapper}>
            <AddIcon fontSize="large" />
            <Typography>{`Liczba zdjęć, które możesz dodać: ${availableImageNumber}`}</Typography>
          </Box>
          <input
            accept={allowedExtensions}
            ref={inputEl}
            type="file"
            onChange={handleOnChange}
            placeholder="prześlij wiele zdjęć"
            multiple
          />
        </Box>
      </>
    );
  }
);

export const ImageUploader = withImageUploader(MultiImage);
